import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import withImmutablePropsToJS from "with-immutable-props-to-js";
import { withRouter } from "react-router-dom";
import { WithLoader } from "storefront/features/shared/components/Loader";
import { ALL_AUCTIONS_PAGE_LOADER } from "storefront/features/shared/utils";

import * as actions from "storefront/features/shared/actions";
import {
  getProducts,
  getPageParams,
} from "storefront/features/shared/selectors";
import ProductGrid from "storefront/features/productGrid/components/ProductGrid";
import { Pagination, Helmet } from "storefront/features/shared/";
import { getTags, getSearchParams } from "storefront/features/shared/utils";
import { metaTags } from "../metaTags";
import withRemoveAuction from "storefront/features/shared/components/RemoveAuction";

class AuctionsWithTags extends PureComponent {
  componentDidMount() {
    const { location, fetchFilteredAuctions, history } = this.props;
    const tags = getTags(location.pathname);
    const pageNumber = getSearchParams(location.search, "page");
    history.action === "PUSH" &&
      fetchFilteredAuctions(tags, ALL_AUCTIONS_PAGE_LOADER, pageNumber);
    document.addEventListener(
      "visibilitychange",
      this.handleVisibilityChange,
      false
    );
  }

  componentWillUnmount() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  }

  handleVisibilityChange = () => {
    if (!document.hidden) {
      this.handleUpdateGrid();
    }
  };

  pageItemHandleClick = (page) => {
    const { location, fetchFilteredAuctions } = this.props;
    const tags = getTags(location.pathname);
    fetchFilteredAuctions(tags, ALL_AUCTIONS_PAGE_LOADER, page);
  };

  handleUpdateGrid = () => {
    const { location, fetchFilteredAuctions } = this.props;
    const tags = getTags(location.pathname);
    const page = getSearchParams(location.search, "page");
    fetchFilteredAuctions(tags, ALL_AUCTIONS_PAGE_LOADER, page);
  };

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const tags = getTags(location.pathname);
    if (tags !== getTags(prevProps.location.pathname)) {
      this.handleUpdateGrid();
    }
  }

  render() {
    const { products, pageParams } = this.props;
    return (
      <>
        <Helmet metaTags={metaTags} />
        <WithLoader loader={ALL_AUCTIONS_PAGE_LOADER}>
          <ProductGrid products={products} />
        </WithLoader>
        <Pagination
          pageItemHandleClick={this.pageItemHandleClick}
          pageParams={pageParams}
        />
      </>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  products: getProducts,
  pageParams: getPageParams,
});

const mapDispatchToProps = (dispatch) => ({
  fetchFilteredAuctions: (tags, loader, page) => {
    dispatch(actions.fetchFilteredAuctionsRequest({ tags, loader, page }));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withImmutablePropsToJS,
  withRemoveAuction
)(AuctionsWithTags);
